import Redux from 'redux';
import { ExportState, ExportActionTypes, EXPORT_INPROGRESS, EXPORT_SUCCESS, EXPORT_FAILURE } from './types';
import { LOGIN_CLEAR_PRELOADED_DATA } from '$/store/login/types';

const initialState: ExportState = {
  isLoading: false,
  error: undefined,
};

const exportReducer: Redux.Reducer<ExportState> = (state = initialState, action: ExportActionTypes): ExportState => {
  switch (action.type) {
    case LOGIN_CLEAR_PRELOADED_DATA:
      return initialState;
    case EXPORT_INPROGRESS:
      return {
        ...state,
        isLoading: true,
        error: undefined,
      };
    case EXPORT_SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: undefined,
      };
    case EXPORT_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default exportReducer;
